import React from "react";
import NavBar from "../../../Shared/Components/NavBar/NavBar";
import SideMenu from "../SideMenu/SideMenu";

const TopBar = ({
  userData,
  isMenuOpen,
  toggleMenu = () => {},
  selectedLanguage,
  setSelectedLanguage = () => {},
  textSize,
  decreaseTextSize = () => {},
  increaseTextSize = () => {},
  toggleHelp = () => {},
  setStartTour = () => {},
  showTooltipChecklist,
  setShowTooltipChecklist,
}) => {
  return (
    <div className="">
      <NavBar setStartTour={setStartTour} selectedLanguage={selectedLanguage} textSize={textSize} toggleMenu={toggleMenu} toggleHelp={toggleHelp} showTooltipChecklist={showTooltipChecklist} setShowTooltipChecklist={setShowTooltipChecklist} />
      {isMenuOpen && (
        <SideMenu
          userData={userData}
          toggleMenu={toggleMenu}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          textSize={textSize}
          decreaseTextSize={decreaseTextSize}
          increaseTextSize={increaseTextSize}
          toggleHelp={toggleHelp}
        />
      )}
    </div>
  );
};

export default TopBar;
